var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
import { TeamType } from "./Team.js";
let PointOpportunityNode = class PointOpportunityNode extends TimestampedResource {
    id;
    name;
    type;
    opportunityDate;
    text() {
        return this.name;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], PointOpportunityNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], PointOpportunityNode.prototype, "name", void 0);
__decorate([
    Field(() => TeamType, { nullable: false }),
    __metadata("design:type", String)
], PointOpportunityNode.prototype, "type", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], PointOpportunityNode.prototype, "opportunityDate", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], PointOpportunityNode.prototype, "text", null);
PointOpportunityNode = __decorate([
    ObjectType({
        implements: [Node],
    })
], PointOpportunityNode);
export { PointOpportunityNode };
//# sourceMappingURL=PointOpportunity.js.map